import {
    GET_EQUITY_DETAILS,
    GET_EQUITY_DETAILS_SUCCESS,
    GET_EQUITY_DETAILS_FAILURE,
} from '../actions';

const initialState = {
    equityDetails: {
        myCaseRef: '',
    },
};

const equityDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EQUITY_DETAILS:
            return {
                ...state,
                ...initialState,
                // myCaseRef: action.myCaseRef,
            };
        case GET_EQUITY_DETAILS_SUCCESS:
            return {
                ...state,
                equityDetails: {
                    myCaseRef: action.myCaseRef,
                },
            };
        case GET_EQUITY_DETAILS_FAILURE:
            return {
                ...state,
                equityDetails: {
                    statusCode: action.statusCode,
                    statusMessage: action.statusMessage,
                },
            };
        default: {
            return { ...state };
        }
    }
};

export default equityDetailsReducer;
